// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Yzd77","modalFooterButton":"ModalNotes_modalFooterButton__1j9CF"};